import { useEffect } from 'react';
import { apiSlice } from '@/store/apiSlice';
import { getWebSocketBaseUrl } from '@/lib/config';
import { useAppDispatch } from '@/store/hooks';

type InfraWsPayload = {
  channel?: string;
  event?: string;
};

/**
 * When another session (or the API after delete) signals infrastructure changes, refresh scenario + infra summary.
 */
export function useExerciseInfrastructureWebSocket(exerciseId: string | undefined) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!exerciseId || typeof window === 'undefined') return;
    const token = window.localStorage.getItem('access_token');
    if (!token) return;

    const base = getWebSocketBaseUrl();
    if (!base) return;

    const qs = new URLSearchParams({ token });
    const url = `${base}/ws/exercise-infrastructure/${encodeURIComponent(exerciseId)}/?${qs.toString()}`;

    let socket: WebSocket;
    try {
      socket = new WebSocket(url);
    } catch {
      return undefined;
    }

    socket.onmessage = (ev) => {
      try {
        const data = JSON.parse(ev.data) as InfraWsPayload;
        if (data.channel !== 'exercise_infrastructure' || data.event !== 'resource_deleted') return;
        dispatch(
          apiSlice.util.invalidateTags([
            { type: 'Infrastructure', id: exerciseId },
            { type: 'ScenarioDetail', id: exerciseId },
            { type: 'ExerciseApprove', id: exerciseId },
          ]),
        );
      } catch {
        /* ignore */
      }
    };

    socket.onerror = () => {
      /* non-fatal */
    };

    return () => {
      socket.close();
    };
  }, [dispatch, exerciseId]);
}
